import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Protection from "./ProtectionTab";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { ApplicationState } from "../../../store";
import * as services from "../../../store/service";
import { Notification } from "../Notification";

const RiskProtectionTab = (props: any) => {
    const [loading, setLoading] = useState(false);
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const dispatch = useDispatch();
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading]);

    const launchRiskManagementTraining = () => {
        setLoading(true);
        services
            .createSessionToken()
            .then((data: any) => {
                setLoading(false);
                window.open(`${data.authapi_base_url}/session?SessionToken=${data.session_token}`, "_blank");
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: "Something went wrong, Please try again.",
                });
            });
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page">Protection</h1>
                </div>
            </div>

            <Protection selectedTab="1" />
            {
                <div className="support-container row">
                    <div className="col-xs-12 row">
                        <div className="box no-padding">
                            <div className="contentBox">
                                <h1>Arm Your Team with Cyber Awareness</h1>
                                <p className="para">
                                    By empowering your staff with an understanding of identity theft risks and red flags, your team becomes an additional line of
                                    defense for your business. Through a secure online connection, at their convenience and yours, members can access a series of
                                    online training modules. Each module features an optional assessment that business owners can use to confirm knowledge retention
                                    and highlight learning gaps.
                                </p>
                            </div>
                            <div className="contentBox">
                                <button
                                    type="button"
                                    className="btn-default btn-primary"
                                    id="btn-launch-risk-management-training"
                                    onClick={() => {
                                        window.addToDataLayer({ event: "Launch Risk Management Training" });
                                        launchRiskManagementTraining();
                                    }}
                                    disabled={loading}
                                >
                                    <span className="btn-text">Launch Risk Management Training</span>
                                </button>
                            </div>
                            <div className="contentBox">
                                <h2>Management Data Security & Privacy</h2>
                                <p className="sectionPara">
                                    This course emphasizes risks associated with the loss or compromise of sensitive data and/or personally identifiable information
                                    (PII), and how companies can protect their businesses and their customers by reducing data security and privacy risks -
                                    ultimately preserving company reputation, customer trust, and ensuring compliance.
                                </p>
                            </div>
                            <div className="contentBox">
                                <h2>Advanced Risk Management Data Security & Privacy</h2>
                                <p className="sectionPara">
                                    This course reviews the basics of data risk management, provides a more in-depth understanding of data and privacy, introduces
                                    an action plan to proactively mitigate risks, and provides case studies for key professional markets.
                                </p>
                            </div>
                            <div className="contentBox">
                                <h2>Risk Management Data Breach Forensics Liability & Remediation </h2>
                                <p className="sectionPara">
                                    This course provides an overview of forensics and cyber security essentials, outlines items to help assess liability and
                                    remediation, and conveys clear benefits of experienced information security professionals.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};
export default RiskProtectionTab;
